// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_organization_staff.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { OrganizationJobPosition } from "./dto_organization_job_position_pb.js";
import { Attribute, CalledVia, Created, Revision } from "./dto_base_pb.js";

/**
 * @generated from enum com.diagnocat.model.OrganizationStaffRoleType
 */
export const OrganizationStaffRoleType = proto3.makeEnum(
  "com.diagnocat.model.OrganizationStaffRoleType",
  [
    {no: 0, name: "OrganizationStaffRoleType_InvalidValue"},
    {no: 1, name: "OrganizationStaffRoleType_FullAccess"},
    {no: 2, name: "OrganizationStaffRoleType_ClinicalAccess"},
    {no: 3, name: "OrganizationStaffRoleType_LimitedClinicalAccess"},
    {no: 4, name: "OrganizationStaffRoleType_NonClinicalMember"},
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStaff
 */
export const OrganizationStaff = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStaff",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "PersonalData", kind: "message", T: OrganizationStaffPersonalData },
    { no: 6, name: "Role", kind: "enum", T: proto3.getEnumType(OrganizationStaffRoleType) },
    { no: 7, name: "JobPositions", kind: "enum", T: proto3.getEnumType(OrganizationJobPosition), repeated: true },
    { no: 8, name: "StampAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "AvatarAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Active", kind: "message", T: OrganizationStaffStatusActive, oneof: "Status" },
    { no: 12, name: "Deleted", kind: "message", T: OrganizationStaffStatusDeleted, oneof: "Status" },
    { no: 21, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "Attributes", kind: "message", T: Attribute, repeated: true },
    { no: 23, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 24, name: "MFARequired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStaffPersonalData
 */
export const OrganizationStaffPersonalData = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStaffPersonalData",
  () => [
    { no: 1, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStaffStatusActive
 */
export const OrganizationStaffStatusActive = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStaffStatusActive",
  [],
);

/**
 * @generated from message com.diagnocat.model.OrganizationStaffStatusDeleted
 */
export const OrganizationStaffStatusDeleted = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationStaffStatusDeleted",
  () => [
    { no: 1, name: "By", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "At", kind: "message", T: Timestamp },
    { no: 3, name: "Via", kind: "enum", T: proto3.getEnumType(CalledVia) },
  ],
);

